var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Tipos de documentos","p-read-link":"docTypes.read.one","p-create-link":"docTypes.create","p-name":"docTypes"}})}
var staticRenderFns = []

export { render, staticRenderFns }